<div class="detail-container">
    <nb-card [nbSpinner]="!!(loading$|async)">
        <nb-card-header>
            <button nbButton ghost status="primary" (click)="navigateBack()">
                <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
            </button>
            <h5>Label: {{ form?.value?.name || 'Neu' }}</h5>
            @if (canEdit() && !isNew()) {
                <wr-edit-delete-button-group [canDelete]="signal(false)"
                                            (edit)="onEdit()"></wr-edit-delete-button-group>
            }
        </nb-card-header>
        <nb-card-body>
            @if (form) {
                <hau-form [formGroup]="form">
                    <hau-form-field label="Name" [validation]="form.validation.name" cols="6">
                        <input nbInput fullWidth formControlName="name" placeholder="Name des Labels">
                    </hau-form-field>

                    <hau-form-field label="Kürzel" [validation]="form.validation.shortcut" cols="3">
                        <input nbInput fullWidth formControlName="shortcut" placeholder="z.B. L1">
                    </hau-form-field>

                    <hau-form-field label="Dimension" [validation]="form.validation.dimension" cols="3">
                        <div class="dimension-control">
                            <wr-dimension-select formControlName="dimension" class="dimension-select"></wr-dimension-select>
                            @if (dimensionLocked()) {
                                <nb-icon class="dimension-info-icon"
                                         pack="eva"
                                         icon="info-outline"
                                         [nbTooltip]="dimensionLockedHint()"></nb-icon>
                            }
                        </div>
                    </hau-form-field>

                    <hau-form-field label="Kategorie" [validation]="form.validation.category" cols="3">
                        <wr-label-category-select formControlName="category"></wr-label-category-select>
                    </hau-form-field>

                    <hau-form-field label="Farbe" [validation]="form.validation.color" cols="9">
                        <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
                    </hau-form-field>

                    <hau-form-field label="Sichtbar" [validation]="form.validation.isVisible" cols="3">
                        <div class="toggle-container">
                            <nb-toggle formControlName="isVisible"></nb-toggle>
                        </div>
                    </hau-form-field>

                    <hau-form-field label="Beschreibung" [validation]="form.validation.description" cols="12">
                        <textarea nbInput fullWidth formControlName="description" rows="4" placeholder="Zusätzliche Informationen..."></textarea>
                    </hau-form-field>
                </hau-form>
            }
        </nb-card-body>
        @if (canEdit()) {
            <nb-card-footer>
                <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
                <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
            </nb-card-footer>
        }
    </nb-card>
</div>
